var _rect, _rect2, _rect3, _rect4, _rect5, _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNftLight = function SvgNftLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.75,
    y: 5.75,
    width: 148.5,
    height: 148.5,
    rx: 74.25,
    stroke: "#F3F3F8",
    strokeWidth: 1.5,
    strokeDasharray: "2 2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 139,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#F3F3F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 12,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#F3F3F8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 31,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#F3F3F8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 137,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#F3F3F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "nft-light_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 14,
    width: 160,
    height: 132
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 14c-21.413 0-40.444 10.197-52.502 26H30c-5.523 0-10 4.477-10 10v60c0 5.523 4.477 10 10 10h17.498c12.058 15.803 31.09 26 52.502 26 21.413 0 40.444-10.197 52.502-26H170c5.523 0 10-4.477 10-10V50c0-5.523-4.477-10-10-10h-17.498C140.444 24.197 121.413 14 100 14Z",
    fill: "red"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#nft-light_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 16,
    width: 128,
    height: 128,
    rx: 64,
    fill: "#F3F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 44,
    width: 64,
    height: 80,
    rx: 10,
    fill: "#2D2062",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.75,
    y: 40.75,
    width: 62.5,
    height: 78.5,
    rx: 9.25,
    fill: "#F3F3F6",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.75 50A9.25 9.25 0 0 1 30 40.75h44A9.25 9.25 0 0 1 83.25 50v53.25h-62.5V50Z",
    fill: "#fff",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.56 69.72a2.591 2.591 0 0 0 3.635-.65 2.66 2.66 0 0 0-.638-3.677 2.591 2.591 0 0 0-3.635.65 2.66 2.66 0 0 0 .639 3.677Zm1.58 11.293c.002-.002.001-.004-.001-.004l-2.675-.01c-1.046-.005-1.6-1.238-.91-2.024l3.817-4.348a1.781 1.781 0 0 1 2.685.009c.707.815 1.97.82 2.683.009l2.873-3.268a2 2 0 0 1 3.012.01l5.531 6.368c1.127 1.297.202 3.317-1.516 3.311l-15.496-.049c-.003 0-.004-.002-.002-.004Z",
    fill: "#CFCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 110,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#E0DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 44,
    width: 64,
    height: 80,
    rx: 10,
    fill: "#2D2062",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.75,
    y: 40.75,
    width: 62.5,
    height: 78.5,
    rx: 9.25,
    fill: "#F3F3F6",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.75 50a9.25 9.25 0 0 1 9.25-9.25h44a9.25 9.25 0 0 1 9.25 9.25v53.25h-62.5V50Z",
    fill: "#fff",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.561 69.72a2.59 2.59 0 0 0 3.634-.65 2.659 2.659 0 0 0-.638-3.677 2.592 2.592 0 0 0-3.635.65 2.66 2.66 0 0 0 .639 3.677Zm1.58 11.293c.001-.002 0-.004-.002-.004l-2.675-.01c-1.046-.005-1.601-1.238-.911-2.024l3.818-4.348a1.782 1.782 0 0 1 2.685.009 1.78 1.78 0 0 0 2.683.009l2.873-3.268a2 2 0 0 1 3.012.01l5.531 6.368c1.127 1.297.202 3.317-1.516 3.311l-15.496-.049c-.003 0-.004-.002-.002-.004Z",
    fill: "#CFCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 110,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#E0DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.125,
    y: 35.9,
    width: 78,
    height: 98,
    rx: 10,
    fill: "#2D2062",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.75,
    y: 31.75,
    width: 76.5,
    height: 96.5,
    rx: 9.25,
    fill: "#F3F3F6",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.75 41A9.25 9.25 0 0 1 71 31.75h58a9.25 9.25 0 0 1 9.25 9.25v67.65h-76.5V41Z",
    fill: "#fff",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.715 67.407a3.148 3.148 0 0 0 4.43-.796c1.008-1.464.66-3.481-.779-4.505a3.148 3.148 0 0 0-4.43.796c-1.008 1.464-.66 3.481.779 4.505Zm1.925 13.834a.003.003 0 0 0-.002-.005l-3.26-.013c-1.277-.005-1.956-1.51-1.116-2.471l4.785-5.478a2 2 0 0 1 3.021.01l.25.29a2 2 0 0 0 3.02.01l3.954-4.52a2 2 0 0 1 3.019.008l7.715 8.93c1.122 1.298.196 3.313-1.519 3.307l-19.864-.063a.003.003 0 0 1-.003-.005Z",
    fill: "#CFCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.313,
    y: 116.75,
    width: 39,
    height: 4.9,
    rx: 2,
    fill: "#E0DFE9"
  }))));
};

export { SvgNftLight as ReactComponent };
export default "data:image/svg+xml;base64,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";